import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { ForecastByRoomTypeReportFormModel, SubFilterEnum } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): ForecastByRoomTypeReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  company: null,
  rates: [],
  roomTypeIds: null,
  gross_revenue: false,
  with_revenue: false,
  currency: null,
  currency_application: null,
  fixed_at: '',
  sub_filter: SubFilterEnum.NONE,
  file_type: 'pdf',
  columns: [],
});
